import { render } from "./ProductsFiltersModal.vue?vue&type=template&id=8a1817b6"
import script from "./ProductsFiltersModal.vue?vue&type=script&lang=js"
export * from "./ProductsFiltersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__